<template>
  <v-list rounded dense v-if="data">
    <v-list-item>
			<v-list-item-content>
				<v-list-item-avatar class="mb-4" size="80" tile v-if="data.picture">
					<v-img :src="data.picture" contain />
				</v-list-item-avatar>

				<v-file-input
					@change="uploadFile"
					accept="image/png, image/jpeg"
					label="Upload image"
					prepend-icon="mdi-image"
					show-size
				/>
			</v-list-item-content>
		</v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-text-field label="Name" required prepend-icon="mdi-face" v-model="data.name" filled class="fullwidth" :rules="[v => !!v || 'Name is mandatory']"></v-text-field>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-text-field label="Department" prepend-icon="mdi-account-group" required v-model="data.department" filled class="fullwidth" :rules="[v => !!v || 'Department is mandatory']"></v-text-field>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-text-field label="Work title" prepend-icon="mdi-account-badge-outline" required v-model="data.title" filled class="fullwidth" :rules="[v => !!v || 'Work title is mandatory']"></v-text-field>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-text-field label="E-mail" prepend-icon="mdi-at" required v-model="data.email" filled class="fullwidth" :rules="[v => !!v || 'E-mail address is mandatory']"></v-text-field>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import FileService from '@/services/FileService'

export default {
  name: 'EmployeeForm',
  props: ['data'],
  components: {
    FileService
  },
  methods: {
		async uploadFile(file) {
			if (file) {
				const { name } = file
				const result = await FileService.uploadS3(name, file)
				if (result) this.$set(this.data, 'picture', result.path)
			}
		},
	},
}
</script>